<div #containerRef>
  <ngx-charts-bar-horizontal-stacked
    #chart
    (window:resize)="resizeChart(containerRef.offsetWidth)"
    [view]="view"
    [scheme]="colorScheme"
    [results]="data"
    [gradient]="gradient"
    [xAxis]="showXAxis"
    [yAxis]="showYAxis"
    [animations]="false"
    [legend]="showLegend"
    [showXAxisLabel]="showXAxisLabel"
    [showYAxisLabel]="showYAxisLabel"
    [xAxisLabel]="xAxisLabel"
    [yAxisLabel]="yAxisLabel"
    [legendTitle]="legendTitle"
    [legendPosition]="legendPosition"
    [barPadding]="barPadding"
    [maxYAxisTickLength]="maxYAxisTickLength"
    [trimYAxisTicks]="trimYAxisTicks"
    [showDataLabel]="true"
  >
  </ngx-charts-bar-horizontal-stacked>
</div>
